<p-toast
  [baseZIndex]="1000"
  [key]="key()"
  styleClass="xlplus:!max-w-[412px] max-w-[395px] !w-fit !h-fit break-words whitespace-normal"
>
  <ng-template let-message #headless let-closeFn="closeFn">
    <div
      data-testid="toast"
      [attr.data-severity]="message.severity"
      class="flex items-start gap-2 p-2 rounded-sm"
      [ngClass]="{
        'bg-[#DFFBEF]': message.severity === 'custom-success',
        'bg-[#FFE7EA] border-[#FFE7EA]': message.severity === 'custom-error' || message.severity === 'error',
        'bg-[#E0F2FE] border-[#E0F2FE]': message.severity === 'custom-info',
        'bg-[#FFF9E6] border-[#FFF9E6]': message.severity === 'custom-warning'
      }"
    >
      @switch (message.severity) { @case ('custom-success') {
      <svg
        class="mt-[2px] flex-shrink-0 cursor-pointer w-[14px] h-[14px] xlplus:w-[16px] xlplus:h-[16px]"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 7C14 10.866 10.866 14 7 14C3.134 14 0 10.866 0 7C0 3.134 3.134 0 7 0C10.866 0 14 3.134 14 7ZM6.19031 10.7064L11.3839 5.51289C11.5602 5.33654 11.5602 5.05058 11.3839 4.87423L10.7452 4.23556C10.5688 4.05918 10.2829 4.05918 10.1065 4.23556L5.87097 8.47107L3.8935 6.4936C3.71714 6.31725 3.43119 6.31725 3.2548 6.4936L2.61614 7.13227C2.43978 7.30862 2.43978 7.59458 2.61614 7.77093L5.55162 10.7064C5.728 10.8828 6.01393 10.8828 6.19031 10.7064Z"
          fill="#1A8B57"
        />
      </svg>
      <div class="font-lato font-normal text-xs xlplus:text-sm text-[#1A8B57]">
        <p [innerHTML]="message.summary"></p>
        @if (message.detail) {
        <p class="line-clamp-1 font-bold">{{ message.detail }}</p>
        }
      </div>
      } @case('custom-error') {
      <svg
        class="mt-[2px] flex-shrink-0 cursor-pointer w-[14px] h-[14px] xlplus:w-[16px] xlplus:h-[16px]"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 0C3.13306 0 0 3.13306 0 7C0 10.8669 3.13306 14 7 14C10.8669 14 14 10.8669 14 7C14 3.13306 10.8669 0 7 0ZM10.4323 8.8375C10.5649 8.97016 10.5649 9.18468 10.4323 9.31734L9.31452 10.4323C9.18185 10.5649 8.96734 10.5649 8.83468 10.4323L7 8.58064L5.1625 10.4323C5.02984 10.5649 4.81532 10.5649 4.68266 10.4323L3.56774 9.31452C3.43508 9.18185 3.43508 8.96734 3.56774 8.83468L5.41935 7L3.56774 5.1625C3.43508 5.02984 3.43508 4.81532 3.56774 4.68266L4.68548 3.56492C4.81814 3.43226 5.03266 3.43226 5.16532 3.56492L7 5.41935L8.8375 3.56774C8.97016 3.43508 9.18468 3.43508 9.31734 3.56774L10.4351 4.68548C10.5677 4.81814 10.5677 5.03266 10.4351 5.16532L8.58064 7L10.4323 8.8375Z"
          fill="#E73A3A"
        />
      </svg>
      <div class="font-lato font-normal text-xs xlplus:text-sm text-[#E73A3A]">
        <p [innerHTML]="message.summary"></p>
        @if (message.detail) {
        <p class="line-clamp-1 font-bold">{{ message.detail }}</p>
        }
      </div>
      } @case('error') {
      <!--
        Same icon/colors as custom-error. The one difference is deliberate:
        `detail` here is NOT line-clamped, because this case exists for toasts
        whose sentence is a full sentence rather than a short label (the
        page-load diagnostic codes) — a 1-line clamp would truncate it.
      -->
      <svg
        class="mt-[2px] flex-shrink-0 cursor-pointer w-[14px] h-[14px] xlplus:w-[16px] xlplus:h-[16px]"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 0C3.13306 0 0 3.13306 0 7C0 10.8669 3.13306 14 7 14C10.8669 14 14 10.8669 14 7C14 3.13306 10.8669 0 7 0ZM10.4323 8.8375C10.5649 8.97016 10.5649 9.18468 10.4323 9.31734L9.31452 10.4323C9.18185 10.5649 8.96734 10.5649 8.83468 10.4323L7 8.58064L5.1625 10.4323C5.02984 10.5649 4.81532 10.5649 4.68266 10.4323L3.56774 9.31452C3.43508 9.18185 3.43508 8.96734 3.56774 8.83468L5.41935 7L3.56774 5.1625C3.43508 5.02984 3.43508 4.81532 3.56774 4.68266L4.68548 3.56492C4.81814 3.43226 5.03266 3.43226 5.16532 3.56492L7 5.41935L8.8375 3.56774C8.97016 3.43508 9.18468 3.43508 9.31734 3.56774L10.4351 4.68548C10.5677 4.81814 10.5677 5.03266 10.4351 5.16532L8.58064 7L10.4323 8.8375Z"
          fill="#E73A3A"
        />
      </svg>
      <div class="font-lato font-normal text-xs xlplus:text-sm text-[#E73A3A]">
        <p [innerHTML]="message.summary"></p>
        @if (message.detail) {
        <p>{{ message.detail }}</p>
        }
      </div>
      } @case('custom-info') {
      <svg
        class="mt-[2px] flex-shrink-0 cursor-pointer w-[14px] h-[14px] xlplus:w-[16px] xlplus:h-[16px]"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 0C3.13428 0 0 3.13541 0 7C0 10.8668 3.13428 14 7 14C10.8657 14 14 10.8668 14 7C14 3.13541 10.8657 0 7 0ZM7 3.10484C7.65473 3.10484 8.18548 3.6356 8.18548 4.29032C8.18548 4.94505 7.65473 5.47581 7 5.47581C6.34527 5.47581 5.81452 4.94505 5.81452 4.29032C5.81452 3.6356 6.34527 3.10484 7 3.10484ZM8.58064 10.2742C8.58064 10.4612 8.42899 10.6129 8.24194 10.6129H5.75806C5.57101 10.6129 5.41935 10.4612 5.41935 10.2742V9.59677C5.41935 9.40972 5.57101 9.25806 5.75806 9.25806H6.09677V7.45161H5.75806C5.57101 7.45161 5.41935 7.29996 5.41935 7.1129V6.43548C5.41935 6.24843 5.57101 6.09677 5.75806 6.09677H7.56452C7.75157 6.09677 7.90323 6.24843 7.90323 6.43548V9.25806H8.24194C8.42899 9.25806 8.58064 9.40972 8.58064 9.59677V10.2742Z"
          fill="#007DA9"
        />
      </svg>
      <div class="font-lato font-normal text-xs xlplus:text-sm text-[#004B65]">
        <p [innerHTML]="message.summary"></p>
        @if (message.detail) {
        <p class="line-clamp-1 font-bold">{{ message.detail }}</p>
        }
      </div>
      } @case('custom-warning') {
      <svg
        class="mt-[2px] flex-shrink-0 cursor-pointer w-[14px] h-[14px] xlplus:w-[16px] xlplus:h-[16px]"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
          fill="#D1B00C"
        />
      </svg>
      <div class="font-lato font-normal text-xs xlplus:text-sm text-[#64550C]">
        <p [innerHTML]="message.summary"></p>
        @if (message.detail) {
        <p class="line-clamp-1 font-bold">{{ message.detail }}</p>
        }
      </div>
      } @default {} }
      <svg
        class="mt-[4px] flex-shrink-0 cursor-pointer w-[9px] h-[9px] xlplus:w-[12px] xlplus:h-[12px]"
        viewBox="0 0 9 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        (click)="closeFn($event)"
      >
        <path
          d="M7.33969 0.300914C7.42801 0.207531 7.53417 0.132804 7.65187 0.0811478C7.76957 0.029492 7.89643 0.00195664 8.02496 0.000169278C8.15349 -0.00161809 8.28107 0.0223788 8.40016 0.0707416C8.51925 0.119104 8.62744 0.190851 8.71833 0.281742C8.80923 0.372632 8.88097 0.480822 8.92933 0.599915C8.9777 0.719009 9.00169 0.846589 8.99991 0.975115C8.99812 1.10364 8.97058 1.2305 8.91893 1.34821C8.86727 1.46591 8.79255 1.57206 8.69916 1.66039L5.88148 4.47807C5.87775 4.4818 5.87479 4.48622 5.87277 4.49109C5.87075 4.49595 5.86971 4.50117 5.86971 4.50644C5.86971 4.51171 5.87075 4.51693 5.87277 4.5218C5.87479 4.52667 5.87775 4.53109 5.88148 4.53481L8.69916 7.35249C8.78967 7.44151 8.86165 7.54757 8.91096 7.66455C8.96027 7.78153 8.98593 7.90712 8.98646 8.03406C8.98699 8.16101 8.96238 8.2868 8.91406 8.40419C8.86573 8.52158 8.79464 8.62823 8.70488 8.71801C8.61513 8.80779 8.50849 8.8789 8.39111 8.92726C8.27373 8.97561 8.14795 9.00025 8.021 8.99975C7.89405 8.99925 7.76846 8.97362 7.65147 8.92433C7.53448 8.87505 7.42841 8.80309 7.33937 8.71261L4.52168 5.89493C4.51796 5.8912 4.51354 5.88824 4.50867 5.88622C4.5038 5.8842 4.49858 5.88316 4.49331 5.88316C4.48804 5.88316 4.48282 5.8842 4.47796 5.88622C4.47309 5.88824 4.46867 5.8912 4.46494 5.89493L1.64726 8.71261C1.55824 8.80311 1.45218 8.8751 1.3352 8.92441C1.21823 8.97372 1.09264 8.99938 0.965695 8.99991C0.83875 9.00044 0.712955 8.97583 0.595567 8.92751C0.478179 8.87918 0.371521 8.80809 0.281746 8.71833C0.19197 8.62858 0.120854 8.52194 0.0724983 8.40456C0.0241429 8.28718 -0.000494379 8.1614 7.51656e-06 8.03445C0.000509412 7.9075 0.0261406 7.78191 0.0754226 7.66492C0.124705 7.54793 0.196662 7.44186 0.287144 7.35282L3.10483 4.53513C3.10856 4.53141 3.11152 4.52699 3.11354 4.52212C3.11556 4.51725 3.1166 4.51203 3.1166 4.50676C3.1166 4.50149 3.11556 4.49627 3.11354 4.49141C3.11152 4.48654 3.10856 4.48212 3.10483 4.47839L0.287144 1.66071C0.109202 1.47989 0.00991847 1.23608 0.0109215 0.982387C0.0119245 0.728695 0.113132 0.485677 0.292499 0.306268C0.471867 0.126858 0.714861 0.0255934 0.968552 0.0245306C1.22224 0.0234678 1.46608 0.122693 1.64694 0.300594L4.46462 3.11828C4.46835 3.12201 4.47277 3.12497 4.47764 3.12699C4.4825 3.12901 4.48772 3.13005 4.49299 3.13005C4.49826 3.13005 4.50348 3.12901 4.50835 3.12699C4.51322 3.12497 4.51764 3.12201 4.52136 3.11828L7.33969 0.300914Z"
          fill="#5F5B5B"
        />
      </svg>
    </div>
  </ng-template>
</p-toast>
